import React from "react";
import LogoImg from "img/logo.png";
import { Link } from "react-router-dom";
import { MobileMenu } from "layout/Header/Menu/Mobile";
import { DesktopMenu } from "layout/Header/Menu/Desktop";
import { Container } from "components/shared/Container";
import { useTamanoPantalla } from "contexts/providers";

export const HeaderNav: React.FC = () => {
  const { isMobile } = useTamanoPantalla();

  return (
    <>
      <header className="py-8 md:py-4">
        <Container>
          <nav className="relative z-50 flex justify-between items-center">
            <div className="flex items-center md:gap-x-12">
              <Link to={`/`} className="-m-1.5 p-1.5">
                <span className="sr-only">Floradibuja</span>
                <img
                  className={isMobile ? "h-8 w-auto" : "h-10 w-auto"}
                  src={LogoImg}
                  alt="Logo Floradibuja"
                />
              </Link>
            </div>
            <div className="flex items-center gap-x-5 md:gap-x-8">
              {isMobile ? (
                <div className="-mr-1 md:hidden">
                  <MobileMenu />
                </div>
              ) : (
                <DesktopMenu />
              )}
            </div>
          </nav>
        </Container>
      </header>
    </>
  );
};
